module.exports = __webpack_public_path__ + "assets/img/airConditioner.8f8d3057.png";